import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import type { AddFieldCommandOptions } from '@cli-types/core-engine/commands.js'
import type { PreparedFieldInsertion } from '@cli-types/next-adapter/commands.js'
import { NON_INTERACTIVE_CONTAINER_TYPES } from '@cli-constants/schema.js'
import { applySlotToField } from '@core-engine/schema/add-field/apply-slot-to-field.js'
import { buildLeafField } from '@core-engine/schema/add-field/build-leaf-field.js'
import { resolveDefaultPlacementTarget } from '@core-engine/schema/add-field/resolve-default-placement-target.js'
import { fail } from '../schema-prompts/fail.js'
import { normalizeOptionList } from './normalize-option-list.js'
import { validateRelationshipTarget } from './validate-relationship-target.js'

export function createNonInteractiveInsertion(
  loaded: LoadedAuthoredGeneratedSchema,
  schemasDir: string,
  options: AddFieldCommandOptions
): PreparedFieldInsertion {
  if (!options.type || !options.field || !options.label) {
    fail('Non-interactive add-field requires --type, --field, and --label.')
  }

  if (NON_INTERACTIVE_CONTAINER_TYPES.has(options.type)) {
    fail(`Non-interactive add-field does not support recursive "${options.type}" fields.`)
  }

  validateRelationshipTarget(schemasDir, options.relationship, options.type)

  const target = resolveDefaultPlacementTarget(loaded, {
    slot: options.slot,
    step: options.step
  })
  const field = applySlotToField(
    loaded,
    target,
    buildLeafField({
      kind: loaded.kind,
      type: options.type,
      name: options.field,
      label: options.label,
      required: options.required,
      multiple: options.multiple,
      creatable: options.creatable,
      options: normalizeOptionList(options),
      relationship: options.relationship
    }),
    options.slot
  )

  return {
    field,
    target,
    order: {
      before: options.before,
      after: options.after
    },
    summary: []
  }
}
